import { render, staticRenderFns } from "./Bacheca.vue?vue&type=template&id=40665fa0&"
import script from "./Bacheca.vue?vue&type=script&lang=js&"
export * from "./Bacheca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports